var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClinicalRecordBlue01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2_00000067238046270139126330000005742206851604889530_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#264D61;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#264D61;stroke-width:25.66;stroke-linecap:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.1,438h341.9c25.8,0,45.7-22.7,42.3-48.3l-28.6-214c-2.8-21.2-20.9-37-42.3-37H119.6 c-20.9,0-38.8,15.2-42.1,35.9l-34.5,214C38.8,414.5,58.8,438,85.1,438z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M349.8,264.8h-64.1c-2.8,0-5.1-2.3-5.1-5.1v-64.1c0-4.4-3.6-7.9-8-7.9h-34.5c-4.4,0-7.9,3.6-7.9,7.9v64.1 c0,2.8-2.3,5.1-5.1,5.1h-64.1c-4.4,0-7.9,3.6-7.9,8v34.5c0,4.4,3.6,8,7.9,8H225c2.8,0,5.1,2.3,5.1,5.1v64.1c0,4.4,3.6,8,7.9,8h34.5 c4.4,0,8-3.6,8-8v-64.1c0-2.8,2.3-5.1,5.1-5.1h64.1c4.4,0,8-3.6,8-8v-34.5C357.7,268.4,354.1,264.8,349.8,264.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M146.3,138.6c25.2-43.4,72.4-68.5,120.6-64.2c63.4,5.7,95.1,59.2,97.9,64.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalRecordBlue01);
export default __webpack_public_path__ + "static/media/clinical_record_blue-01.7e7ffea93ea8b2b981e2c94abd42e21a.svg";
export { ForwardRef as ReactComponent };